module.exports = __webpack_public_path__ + "static/media/burger.e9f1f660.svg";